import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.11 Case 11</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="self_assessment_111"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case 111. This is a negative case. I’m
                starting here at the level of the cerebellum and then we will
                start moving up one slice at a time. One thing that might be
                confusing is there is one slice here, where it looks like there
                is poor gray-white contrast just as we get to the bottom of the
                occipital cortex on our way up. But, it is very clear that this
                quickly resolves and the white-matter tracts become visible, and
                the gray-white contrast becomes clear. This type of temporary
                loss of gray-white contrast is not uncommon just as one begins
                to enter into the area of cortex. In the frontal cortex, there
                continues to be gray-white contrast. When compared to other
                cases this may look like there is less gray-white contrast than
                you have seen before. However, this gray-white contrast is still
                within the normal range and the white-matter tracts are clearly
                delineated. We continue to proceed upward, where the whitematter
                tracts are clearly shown here and the gray-white contrast is
                maintained, all through here. Compared to other cases, the
                overall gray-white contrast and this is seen consistently
                through this case in all areas of the brain, is a little less
                but because it is consistent, and because there are no areas of
                clear loss of gray-white contrast, the study is negative. If
                you called this case positive, it will be useful to review it
                again on the MIMcloud viewer and note the level of gray-white
                contrast on this normal and negative study.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-10"
          nextLesson="/module-3/module-3-0-12"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_760903579&entry_id=1_u5e7v41y&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_u5e7v41y"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
